//! Her data eklediğinde dataVisibilities: [true, true, true], içine eklemeyi unutma

/*
    menuOrder'a göre menüde sıralanırlar ve reducerdaki dataVisibilities menuorder ile aynı sırada olmalıdır
    menuTypes; basic, group
    type: area, marker, line
    "isChildExist": true,
    "isChildStatic": true,
    childrenList
    isChildDynamic ise bu state'e eklenir state key eklenir state'e bu key ile ulaşılır
        childrenDynamicStateKey tanımı yapılmalı
*/
export const getInitialDatasetValue = () => {
    sessionStorage.setItem("DATASET", JSON.stringify(DATASET));
    return DATASET;
}

export const DATASET =
    [
        {
            "id": "anavatan",
            "menuOrder": 0,
            "menuItemType": "basic",
            "type": "area",
            "isUnitedData": false,
            "name": "Vatan Toprağı Sınırları",
            "data": "trmap",
            "popupContent": "Vatan Toprağı 783.563 km²",
            "styles": {
                color: '#fff',
                weight: 1,
                fillOpacity: 0,
                fillColor: '#ff1717',
            }
        },
        {
            "id": "mavivatan",
            "menuOrder": 1,
            "menuItemType": "basic",
            "type": "area",
            "isUnitedData": true,
            "name": "Mavi Vatan Haritası",
            "data": "TURKEY_SEAS",
            "styles": {
                color: '#fff',
                weight: 1,
                fillOpacity: 0.1,
                fillColor: '#62C2F0',
            }
        },
        {
            "id": "kktclandmap",
            "menuOrder": 2,
            "menuItemType": "basic",
            "type": "area",
            "isUnitedData": false,
            "name": "Kuzey Kıbrıs Türk Cumhuriyeti",
            "data": "cyprus",
            "popupContent": "Kuzey Kıbrıs Türk Cumhuriyeti",
            "styles": {
                color: '#fff',
                weight: 0.5,
                fillOpacity: 0.2,
                fillColor: '#ff1717',
            }
        },
        {
            "id": "bluehomelandnegotiationlines",
            "isChildExist": true,
            "isChildStatic": true,
            "menuOrder": 3,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "name": "Mavi Vatan Sınır Çizgileri",
            "childrenList": [
                {
                    "index": 0,
                    "belongingkey": "bluehomelandNegotiationBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "2019 Türkiye-Libya Mutabakatı",
                    "data": "trlibyaborder",
                    "popupContent": "2019 Türkiye-Libya Mutabakatı",
                    "styles": {
                        color: '#379944',
                        weight: 5,
                        pathType: '4 1 3'
                    }
                },
                {
                    "index": 1,
                    "belongingkey": "bluehomelandNegotiationBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Türkiye - Mısır",
                    "data": "trmisirborder",
                    "popupContent": "Türkiye Mısır ana karalar arası ortay hat",
                    "styles": {
                        color: '#fff',
                        weight: 4,
                        pathType: '4 1 3'
                    }
                },
                {
                    "index": 2,
                    "belongingkey": "bluehomelandNegotiationBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Türkiye - İsrail Deniz Sınırı",
                    "data": "trisrailborder",
                    "popupContent": "Türkiye-İsrail karşılıklı kıyıları göz önüne alınarak yapılacak; olası Türkiye-İsrail Anlaşması sonucu oluşan sınırlar",
                    "styles": {
                        color: '#fff',
                        weight: 4,
                        pathType: '4 1 1'
                    }
                },
                {
                    "index": 3,
                    "belongingkey": "bluehomelandNegotiationBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Türkiye - Lübnan Deniz Sınırı",
                    "data": "trlubnanborder",
                    "popupContent": "Türkiye-Lübnan karşılıklı kıyıları göz önüne alınarak yapılacak; olası Türkiye-Lübnan Anlaşması sonucu oluşan sınırlar",
                    "styles": {
                        color: '#fff',
                        weight: 4,
                        pathType: '4 1 1'
                    }
                }
            ]
        },
        {
            "id": "trlibyakomsukiyilar",
            "menuOrder": 0,
            "menuItemType": "basic",
            "type": "area",
            "isUnitedData": false,
            "name": "Türkiye-Libya Komşu Kıyılar",
            "data": "trlibyakomsukiyilar",
            "popupContent": "Türkiye-Libya Karşılıklı Komşu Kıyılar",
            "styles": {
                color: '#fff',
                weight: 1,
                fillOpacity: 0.5,
                fillColor: '#3D4A2C',
            }
        },
        {
            "id": "trislands",
            "menuOrder": 4,
            "menuItemType": "basic",
            "type": "marker",
            "isUnitedData": true,
            "name": "Türk Adaları",
            "data": "TURKEY_ISLANDS"
        },
        {
            "id": "grislands",
            "menuOrder": 5,
            "menuItemType": "basic",
            "type": "marker",
            "isUnitedData": true,
            "name": "Yunan Adaları",
            "data": "GREECE_ISLANDS"
        },
        {
            "id": "blackseaeez",
            "menuOrder": 6,
            "menuItemType": "basic",
            "type": "area",
            "isUnitedData": true,
            "name": "Karadeniz Ülkelerin MEB Bölgeleri",
            "data": "BLACKSEA_EEZ_ZONES"
        },
        {
            "id": "countries",
            "isChildExist": true,
            "isChildStatic": true,
            "menuOrder": 3,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "name": "Ülke Sınırları",
            "childrenList": [
                {
                    "index": "0",
                    "belongingkey": "countries",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Mısır",
                    "data": "egypt",
                    "popupContent": "Mısır",
                    "styles": {
                        color: '#fff',
                        weight: 2,
                        fillOpacity: 0.3,
                        fillColor: '#494C52'
                    }
                },
                {
                    "index": "1",
                    "belongingkey": "countries",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Libya",
                    "data": "libya",
                    "popupContent": "Libya",
                    "styles": {
                        color: '#fff',
                        weight: 2,
                        fillOpacity: 0.3,
                        fillColor: '#494C52',
                    }
                },
                {
                    "index": "2",
                    "belongingkey": "countries",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Yunanistan",
                    "data": "greece",
                    "popupContent": "Yunanistan",
                    "styles": {
                        color: '#fff',
                        weight: 0.5,
                        fillOpacity: "0.3",
                        fillColor: '#494C52'
                    }
                },
            ]
        },
        {
            "id": "acctoGreeceBorders",
            "isChildExist": true,
            "isChildStatic": true,
            "menuOrder": 3,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "name": "Yunanistan'a Göre Akdeniz-Adalar Denizi Deniz Yetki Alanları",
            "childrenList": [
                {
                    "index": 0,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Sevilla Anlaşmasına göre Yunanistan'nın Sahip Olduğu Münhasır Ekonomik Bölge",
                    "data": "sevillagreez",
                    "popupContent": "Sevilla Anlaşmasına göre Yunanistan'nın Sahip Olduğu Münhasır Ekonomik Bölge",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 1,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Sevilla Anlaşmasına göre Türkiye'nin Sahip Olduğu Münhasır Ekonomik Bölge",
                    "data": "sevillatreez",
                    "popupContent": "Sevilla Anlaşmasına göre Türkiye'nin Sahip Olduğu Münhasır Ekonomik Bölge",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 2,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Sevilla Anlaşmasına göre Sözde Kıbrıs Cumhuriyeti'nin Sahip Olduğu Münhasır Ekonomik Bölge",
                    "data": "sevillacypruseez",
                    "popupContent": "Sevilla Anlaşmasına göre Sözde Kıbrıs Cumhuriyeti'nin Sahip Olduğu Münhasır Ekonomik Bölge",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 3,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Suriye Münhasır Ekonomik Bölgesi",
                    "data": "syriaeez",
                    "popupContent": "Suriye Münhasır Ekonomik Bölgesi",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 4,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Lübnan Münhasır Ekonomik Bölgesi",
                    "data": "lubnaneez",
                    "popupContent": "Lübnan Münhasır Ekonomik Bölgesi",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 5,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Sözde İsrail Münhasır Ekonomik Bölgesi",
                    "data": "israileez",
                    "popupContent": "Sözde İsrail Münhasır Ekonomik Bölgesi",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                },
                {
                    "index": 6,
                    "belongingkey": "accToGreeceBorders",
                    "menuItemType": "basic",
                    "type": "line",
                    "isUnitedData": false,
                    "name": "Mısır Münhasır Ekonomik Bölgesi",
                    "data": "misireez",
                    "popupContent": "Mısır Münhasır Ekonomik Bölgesi",
                    "styles": {
                        color: '#fff',
                        weight: 3,
                    }
                }
            ]
        },
        //Dinamik Data
        {
            "id": "drillShipsLastLocations",
            "name": "Sondaj Filomuz",
            "type": "marker",
            "isChildExist": true,
            "isChildStatic": false,
            "menuOrder": 9,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "styles": {
                color: '#fff',
                weight: 3,
            }
        },
        {
            "id": "navtexAreas",
            "name": "Navtex - Notam Alanları",
            "type": "polygon",
            "isChildExist": true,
            "isChildStatic": false,
            "menuOrder": 10,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "styles": {
                color: '#fff',
                weight: 3,
            }
        },
        {
            "id": "straits",
            "isChildExist": true,
            "isChildStatic": true,
            "menuOrder": 3,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "name": "Boğazlar ve Kanallar",
            "childrenList": [
                {
                    "index": 0,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İstanbul Boğazı",
                    "data": "istanbulStraits",
                    "popupContent": "İstanbul Boğazı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                },
                {
                    "index": 1,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Çanakkale Boğazı",
                    "data": "canakkaleStraits",
                    "popupContent": "Çanakkale Boğazı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                },
                {
                    "index": 2,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Cebeli Tarık Boğazı",
                    "data": "gibraltarStraits",
                    "popupContent": "Cebeli Tarık Boğazı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                },
                {
                    "index": 3,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Hürmüz Boğazı",
                    "data": "hormuzStraits",
                    "popupContent": "Hürmüz Boğazı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                },
                {
                    "index": 4,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Süveş Kanalı",
                    "data": "suezcanal",
                    "popupContent": "Süveş Kanalı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                },
                {
                    "index": 5,
                    "belongingkey": "straits",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Babülmendep Boğazı",
                    "data": "bab-el-mandeb",
                    "popupContent": "Babülmendep Boğazı",
                    "styles": {
                        color: '#0000FF',
                        weight: 1,
                        fillOpacity: 0.6,
                        fillColor: '#0000FF',
                    }
                }
            ]
        },
        //Saruhan Adaları
        // {
        //     //Rodos, Çoban, Limoniye, Kerpe, Sömbeki, Kızılhisar (Meis), İlkil, İncirli, Yalı, İstanköy, İstanbulya, Kilimli, İleriye, Ilıpsi, Herke ve Batnaz
        //     "id": "SaruhanAdalari",
        //     "isChildExist": true,
        //     "isChildStatic": true,
        //     "menuOrder": 3,
        //     "menuItemType": "accordion",
        //     "isUnitedData": false,
        //     "name": "Saruhan Adaları",
        //     "childrenList": [
        //         {
        //             "index": 0,
        //             "belongingkey": "SaruhanAdalari",
        //             "menuItemType": "basic",
        //             "type": "area",
        //             "isUnitedData": false,
        //             "name": "Rodos Adası",
        //             "data": "SaruhanAdalari/rodos",
        //             "popupType": "featurePopup",
        //             "popupTitle": "Rodos Adası",
        //             "popupSubtitle": "Saruhan Adaları",
        //             "popupData": {
        //                 "Egemenlik Hakkı": "Yunanistan",
        //                 "Yüzölçümü": "1.401 km²",
        //                 "Rumca Adlandırması": "Rodhos",
        //             },
        //             "styles": {
        //                 color: '#fff',
        //                 weight: 1,
        //                 fillOpacity: 0.5,
        //                 fillColor: '#FF8C00',
        //             },
        //         },

        //     ]
        // },
        {
            //Rodos, Çoban, Limoniye, Kerpe, Sömbeki, Kızılhisar (Meis), İlkil, İncirli, Yalı, İstanköy, İstanbulya, Kilimli, İleriye, Ilıpsi, Herke ve Batnaz
            "id": "MenteseAdalari",
            "isChildExist": true,
            "isChildStatic": true,
            "menuOrder": 3,
            "menuItemType": "accordion",
            "isUnitedData": false,
            "name": "Menteşe Adaları",
            "childrenList": [
                {
                    "index": 0,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Rodos Adası",
                    "data": "MenteseAdalari/rodos",
                    "popupType": "featurePopup",
                    "popupTitle": "Rodos Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "1.401 km²",
                        "Rumca Adlandırması": "Rodhos",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 1,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Herke Adası",
                    "data": "MenteseAdalari/herke",
                    "popupType": "featurePopup",
                    "popupTitle": "Herke Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "26,99 km²",
                        "Rumca Adlandırması": "Khalkia",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 2,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Kerpe Adası",
                    "data": "MenteseAdalari/kerpe",
                    "popupType": "featurePopup",
                    "popupTitle": "Kerpe Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "302,2 km²",
                        "Rumca Adlandırması": "Karpathos - Scarpanto",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 3,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Çoban-Kaşot Adası",//Kaşot
                    "data": "MenteseAdalari/coban",
                    "popupType": "featurePopup",
                    "popupTitle": "Çoban-Kaşot Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "66,42 km²",
                        "Rumca Adlandırması": "Kaso",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.4,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 4,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İlyaki-İlkil-Papazlık Adası",
                    "data": "MenteseAdalari/ilyaki",
                    "popupType": "featurePopup",
                    "popupTitle": "İlyaki-İlkil-Papazlık  Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "64.525 km²",
                        "Rumca Adlandırması": "Tilos-Piskopi",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 5,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İncirli Adası",
                    "data": "MenteseAdalari/incirli",
                    "popupType": "featurePopup",
                    "popupTitle": "İncirli Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "50,06 km",
                        "Rumca Adlandırması": "Nissiros",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 6,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İstanköy Adası",
                    "data": "MenteseAdalari/istankoy",
                    "popupType": "featurePopup",
                    "popupTitle": "İstanköy Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "287,2 km²",
                        "Rumca Adlandırması": "Kos",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 7,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Sömbeki Adası",
                    "data": "MenteseAdalari/sombeki",
                    "popupType": "featurePopup",
                    "popupTitle": "Sömbeki Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "65,75 km²",
                        "Rumca Adlandırması": "Symi",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 8,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Batnoz-Batnos Adası",
                    "data": "MenteseAdalari/batnaz",
                    "popupType": "featurePopup",
                    "popupTitle": "Batnoz-Batnos Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "34,6 km²",
                        "Rumca Adlandırması": "Patmos",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 9,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İstanbulya Adası",
                    "data": "MenteseAdalari/istanbulya",
                    "popupType": "featurePopup",
                    "popupTitle": "İstanbulya Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "96,9 km²",
                        "Rumca Adlandırması": "Astipalaia",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 10,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Kelemez-Kilimli Adası",
                    "data": "MenteseAdalari/kelemez",
                    "popupType": "featurePopup",
                    "popupTitle": "Kelemez-Kilimli Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "134,5 km²",
                        "Rumca Adlandırması": "Kalymnos",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 11,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "Kızılhisar Adası",
                    "data": "MenteseAdalari/kizilhisar",
                    "popupType": "featurePopup",
                    "popupTitle": "Kızılhisar Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "~12 km²",
                        "Rumca Adlandırması": "Meis",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır.",
                        "Statü": "Gayri askeri statüdeki Kızılhisar Adası askerileştirilmiş ve silahlahlandırılmıştır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 12,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İleriye-İleryoz  Adası",
                    "data": "MenteseAdalari/ileriye",
                    "popupType": "featurePopup",
                    "popupTitle": "İleriye-İleryoz Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "74,17 km²",
                        "Rumca Adlandırması": "Leros",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                },
                {
                    "index": 13,
                    "belongingkey": "MenteseAdalari",
                    "menuItemType": "basic",
                    "type": "area",
                    "isUnitedData": false,
                    "name": "İlipsi-Eşekler  Adası",
                    "data": "MenteseAdalari/esekler",
                    "popupType": "featurePopup",
                    "popupTitle": "İlipsi-Eşekler Adası",
                    "popupSubtitle": "Menteşe Adaları",
                    "popupData": {
                        "Egemenlik Hakkı": "Yunanistan",
                        "Yüzölçümü": "17,35 km²",
                        "Rumca Adlandırması": "Lipsi",
                        "Açıklama": "Lozan Barış Antlaşması'nın 15. Maddesi ile İtalya'ya verilen adaların içerisinde yer alır."
                    },
                    "styles": {
                        color: '#fff',
                        weight: 1,
                        fillOpacity: 0.5,
                        fillColor: '#FF8C00',
                    },
                }

            ]
        },
        // {
        //     "type": "basic",
        //     "name": "Silahlandırılan Yunan Adaları"
        // },
        // {
        //     "type": "group",
        //     "name": "Son Navtex İlanları"
        // },
        // {
        //     "type": "group",
        //     "name": "Sondaj Faaliyetleri"
        // }
    ]



/*Parent Template && Child*/
// {
//     "id": "bluehomelandnegotiationlines",
//     "name": "Mavi Vatan Sınır Çizgileri",
//     "menuOrder": 3, //!menüde gösterileceği konum
//     "menuItemType": "accordion", //! menüde nasıl gösterilecek
//     "isUnitedData": false, //! birleştirilmiş data mı?
//     "isChildExist": true,  //!çoçuğu var mı
//     "isChildStatic": true, //!çoçuğu var ise statik mi dinamik mi
//     "childrenList": [
//         {
//             "name": "2019 Türkiye-Libya Mutabakatı",
//             "belongingkey": "bluehomelandNegotiationBorders", //! cocukların ait olduğu global state adresi
//             "menuItemType": "basic",
//             "type": "line",
//             "isUnitedData": false,
//             "data": "trlibya_border",
//             "popupContent": "2019 Türkiye-Libya Mutabakatı",
//             "styles": {
//                 color: '#1f2021',
//                 weight: 1,
//                 fillOpacity: 0.6,
//                 fillColor: '#ff1717',
//             }
//         }
//     ],
//     "styles": {
//         color: '#1f2021',
//         weight: 1,
//         fillOpacity: 0.6,
//         fillColor: '#ff1717',
//     }
// }
